import React, { useEffect } from 'react';
import { Header } from '../Header';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Footer } from '../Footer';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProfile } from '../../store/slices/profileSlice';
import { Spinner } from 'react-bootstrap';

import { BottomNavigation } from '../BottomNavigation';

export const Layout = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isHomepage = pathname === '/';
    const isVideoFeed = pathname === '/video-feed';

    const { isAuthenticated } = useSelector((state) => state.auth);
    const { profile, loading } = useSelector((state) => state.profile);

    useEffect(() => {
        document.body.classList.toggle('homepage', isHomepage);
        return () => document.body.classList.remove('homepage');
    }, [isHomepage]);

    // Load profile if authenticated and not loaded yet
    useEffect(() => {
        if (isAuthenticated && !profile && !loading.profile) {
            dispatch(fetchProfile());
        }
    }, [isAuthenticated, profile, loading.profile, dispatch]);

    // Global guard: Redirect to onboarding if not completed
    useEffect(() => {
        if (isAuthenticated && profile) {
            const hasLanguages = profile.languages && profile.languages.length > 0;
            const needsScreening = profile.user_type === 'teacher' && (profile.isQuestionComplete === false || profile.screening_status === 'rejected');
            const isPendingScreening = profile.user_type === 'teacher' && profile.screening_status === 'pending';

            if (needsScreening || !hasLanguages || isPendingScreening) {
                navigate('/onboarding');
            }
        }
    }, [isAuthenticated, profile, navigate]);

    // Show a loading screen if logged in but profile is still loading to avoid brief content flashes
    if (isAuthenticated && !profile) {
        return (
            <div className="d-flex align-items-center justify-content-center vh-100 bg-light" style={{ minHeight: '100vh' }}>
                <div className="text-center">
                    <Spinner animation="border" variant="primary" className="mb-3" />
                    <div className="text-gray-600 fw-bold text-sm">Loading your account details...</div>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Common Menubar Component */}
            <Header />

            <div className="main-content-wrapper">
                <Outlet />
            </div>

            {!isVideoFeed && <Footer />}

            {/* Common Bottom Navigation Bar */}
            {/* <BottomNavigation /> */}
        </>
    )
}
